import { getCopyStatusIcon } from './Utils';

interface ResponseToolsProps {
  id: string;
  responseType: string;
  responseContent: string;
  copyStatus: Record<string, number>;
  handleCopyChat: (id: string, content: string) => void;
  handleDownloadChatAsWord: (messageId: string) => void;
  deepResearchDownload: string;
  deepResearchRegenerateIcon: string;
  onRegenerate?: (id: string) => void;
  isFinalReady: boolean;
  isLastMessage: boolean;
}

const ResponseTools: React.FC<ResponseToolsProps> = ({
  id,
  responseType,
  responseContent,
  copyStatus,
  handleCopyChat,
  handleDownloadChatAsWord,
  deepResearchDownload,
  deepResearchRegenerateIcon,
  onRegenerate,
  isFinalReady,
  isLastMessage
}) => {
  const shouldShow =
    responseType === 'clarify' ||
    responseType === 'followup' ||
    (responseType === 'final' && isFinalReady);

  if (!shouldShow) return null;

  return (
    <div
      className={`deep-research-chat-tools ${
        responseType === 'final' ? 'final-' : ''
      }answer-section-tools`}>
      <span
        className='deep-research-chat-tools-icon'
        title={
          copyStatus[`${id}-answer`] === 0 || copyStatus[`${id}-answer`] === undefined
            ? 'Copy to clipboard'
            : copyStatus[`${id}-answer`] === 1
              ? 'Copied!'
              : 'Copy failed'
        }
        onClick={() => handleCopyChat(`${id}-answer`, responseContent)}>
        {getCopyStatusIcon(copyStatus[`${id}-answer`] || 0)}
      </span>
      <span
        className='deep-research-chat-tools-icon'
        onClick={() => handleDownloadChatAsWord(id)}
        title='Download chat'>
        <img src={deepResearchDownload} alt='download icon' />
      </span>
      {isLastMessage && (
        <span
          title='Regenerate response'
          className='deep-research-chat-tools-icon'
          onClick={() => onRegenerate && onRegenerate(id)}
          style={{ cursor: 'pointer' }}>
          <img className='regenerate-icon' src={deepResearchRegenerateIcon} alt='regenerate icon' />
        </span>
      )}
    </div>
  );
};

export default ResponseTools;
